/**
 * @author        quanquan
 * @dateTime      2020-08-18 15:53:09
 * @description
 */

import Vue from 'vue'
import store from '@/conf/home/store'
import { basicsRouterMap, extendRouterMap } from '@/conf/home/router'
import Ps from '@/module/ps'

// domian protocol
const protocol = `${document.location.protocol}//`

// Tie the array
const routerMap = _(extendRouterMap).map('children').filter().flatMap().value()

// Recursive formatting
const handlerResList = (arr) => {
  return arr.reduce((p, c) => {
    p[c.path] = c.children
      ? handlerResList(c.children)
      : {
        name: c.meta.title || '',
        path: c.path
      }
    return p
  }, {})
}

// ignore Url
export const ignoreUrl = handlerResList(_.concat(basicsRouterMap, routerMap))

export const xiaomiEnv = {
  production: {
    url: `${protocol}xiaomi.hydee.cn/hdsec/merchantLogin`
  },
  uat: {
    url: `${protocol}xm.uat.ydjia.cn/hdsec/merchantLogin`
  },
  test: {
    url: `${protocol}xm.test.ydjia.cn/hdsec/merchantLogin`
  },
  dev: {
    url: `${protocol}xm.dev.ydjia.cn/hdsec/merchantLogin`
  }
}

export const appResList = [
  {
    'appCode': 'app',
    'reEngSystem': 'app',
    'reModule': '用户管理',
    'reMenu': '',
    'reButton': '',
    'reMethod': '',
    'rePath': 'app-users',
    'reUrl': '',
    'reIcon': '&#xe65a;',
    'children': [
      {
        'children': [],
        'appCode': 'app',
        'reEngSystem': 'app',
        'reModule': '用户管理',
        'reMenu': '用户信息',
        'reButton': '',
        'reMethod': '',
        'rePath': 'app-users-personal',
        'reUrl': '/app-users/personal'
      },
      {
        'children': [],
        'appCode': 'app',
        'reEngSystem': 'app',
        'reModule': '用户管理',
        'reMenu': '修改密码',
        'reButton': '',
        'reMethod': '',
        'rePath': 'app-users-password',
        'reUrl': '/app-users/password'
      }
    ]
  }
]

export const isParams = (vPath, path) => {
  const curPath = _.split(vPath, ':')
  if (_.size(curPath) === 1) {
    return false
  } else {
    const $vPath = curPath[0].slice(0, curPath[0].length - 1)
    const lastId = _.last(_.split(path, '/'))
    const isNumber = _.isNumber(Number(lastId))
    const $path = isNumber ? _.replace(path, `/${lastId}`, '') : path
    return $vPath === $path
      ? { pName: `:${curPath[1]}`, pValue: lastId }
      : false
  }
}

export const getParents = (vefPath, nodes, path) => {
  if (_.isUndefined(path)) {
    path = []
  }
  for (let i = 0; i < nodes.length; i++) {
    let tmpPath = path.concat()
    const item = nodes[i]
    tmpPath.push(item.path)
    if (!_.isEmpty(item.redirect)) {
      tmpPath.push(item.redirect)
    }
    if (!_.isEmpty(item.activeSubMenu)) {
      tmpPath.push(item.activeSubMenu)
    }
    if (vefPath === item.path || _.isObject(isParams(item.path, vefPath))) {
      return tmpPath
    }
    if (item.children) {
      const findResult = getParents(vefPath, item.children, tmpPath)
      if (findResult) {
        return findResult
      }
    }
  }
}

export const isSelectMenu = (d, b) => {
  const is = v => b.includes(v)
  let flag = false
  _.map(d, v => {
    if (is(v)) {
      flag = true
    }
  })
  return flag
}

export const handlerCurrentMenu = (phasePaths) => {
  const { userInfo } = Vue.prototype.__MCoptions
  const is = v => phasePaths.includes(v)
  const resList = [...userInfo.resList, ...appResList]
  let index = null

  // 恶心的查找
  _.map(resList, (v, i) => {
    if (is(v.reUrl)) {
      index = i
    } else {
      _.map(v.children, (v1) => {
        if (is(v1.reUrl)) {
          index = i
        } else {
          _.map(v1.children, v2 => {
            if (is(v2.reUrl)) {
              index = i
            }
          })
        }
      })
    }
  })
  store.commit('common/setCurrentMenuData', resList[index])
}

export const handlerReEngSystem = v => {
  switch (v) {
    case 'cloud_business':
      return 'cloud'
    case 'hdsec_manager':
      return 'hdsec'
    case '':
      return 'app'
    default:
      return v
  }
}

export const ignoreRePath = [
  'add',
  'delete',
  'audit',
  'download',
  'batch-add',
  'batch-audit',
  'batch-delete',
  'batch-operGoods',
  'distribution',
  'commodity-combine',
  'reducedGift',
  'addPriceBuy',
  'limitTimeDiscount',
  'moreBuyDiscount',
  'coupons',
  'paymentGift',
  'memberVoucher',
  'newcomer',
  'birthdayGift',
  'groupBooking',
  'comment',
  'openAD',
  'memberDay',
  'superMemberDay',
  'delivery',
  'scratchers',
  'bigWheel',
  'exchangeMall',
  'signSet',
  'goodsShare',
  'activityShare',
  'meituan',
  'export',
  'export-log',
  'refund',
  'immediate-delivery',
  'auth',
  'lifting',
  'set',
  'transfer',
  'modify-order',
  'inventoryDedRecord',
  'taskProgress',
  'supplierInventory',
  'editStoreInventory',
  'editStorePrice',
  'editInventoryPrice',
  'syncInventoryPrice',
  'syncConsultation',
  'sync',
  'platform',
  'inventory',
  'price',
  'lockStock',
  'unlockStock',
  'goods-return-report',
  'order-return-report',
  'goods-sales-report',
  'order-sales-report',
  'businessStatus',
  'emp_batch_export',
  'role_batch_export',
  'taskProgress',
  'editStoreInventory',
  'editScaleInventory',
  'inventoryDedRecord',
  'editStorePrice',
  'sync',
  'edit'
]
export const ignoreRePathExp = /^(btn|tab)-(\d+|\$\S+)$/

export const ignoreMenuPath = () => {
  let paths = store.state.common.currentParentPath

  // medical
  // paths = Ps.routerIgnore.medicalIgnoreMenuPath(paths)
  // cloud
  paths = Ps.routerIgnore.cloudIgnoreMenuPath(paths)
  // merchant
  paths = Ps.routerIgnore.merchantIgnoreMenuPath(paths)
  // honey
  // paths = Ps.routerIgnore.honeyIgnoreMenuPath(paths)
  // hdsec
  // paths = Ps.routerIgnore.hdsecIgnoreMenuPath(paths)
  // commodity
  paths = Ps.routerIgnore.commodityIgnoreMenuPath(paths)
  // marketing
  // paths = Ps.routerIgnore.marketingIgnoreMenuPath(paths)

  return paths
}

export const handlerRouteItem = (routeItem) => {
  if (routeItem.path === '/marketing/activity/list/:type') {
    const { pQuery: { pValue } } = routeItem
    if (pValue === '11') {
      _.assign(routeItem, {
        meta: { title: '限时优惠' }
      })
    }
    if (pValue === '14') {
      _.assign(routeItem, {
        meta: { title: '满减满赠' }
      })
    }
    if (pValue === '15') {
      _.assign(routeItem, {
        meta: { title: '加价购' }
      })
    }
    if (pValue === '21') {
      _.assign(routeItem, {
        meta: { title: '多买优惠' }
      })
    }
  }

  return routeItem
}

export const helpToggleArr = {
  'index': '/home'
}

export const handlerReUrls = (resList) => {
  if (_.isEmpty(resList)) {
    return []
  }
  const t = {}
  const h = arr => {
    return arr.reduce((p, c) => {
      if ((c.reUrl || !_.isEmpty(helpToggleArr[c.rePath])) && _.isEmpty(c.reButton)) t[`${handlerReEngSystem(c.appCode) === 'app' ? '' : `/${handlerReEngSystem(c.appCode)}`}${c.reUrl || helpToggleArr[c.rePath]}`] = c.id
      c.children && h(c.children)
    }, {})
  }
  h(resList)
  return t
}



// WEBPACK FOOTER //
// ./src/js/module/layout/_source/utils.js